export default {
      id: "ic_accessibilite-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_accessibilite-usage",
      toString: function () {
        return this.url;
      }
    }